import { PictureScore } from "@/components/molecules/PictureScoreLabel";

export function pictureScore(pictureScore: number): string {
  if (pictureScore < 0.2) {
    return PictureScore.BAD;
  } else if (pictureScore >= 0.2 && pictureScore <= 0.5) {
    return PictureScore.GOOD;
  } else {
    return PictureScore.EXCELLENT;
  }
}

